<template>
    <img :src="logoUrl" alt="" class="logo" @click="goHome"/>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LogoIndex',
  computed: {
    ...mapState(['logoUrl'])
  },
  methods: {
    goHome () {
      this.$router.push('/home').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err // 重新抛出其他类型的错误
        }
      })
    }
  }
}
</script>

<style>
  .logo {
    width: 176px;
    height: 66px;
    -o-object-fit: contain;
    object-fit: contain;
    cursor: pointer;
  }
</style>
